import React from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Typography,
  Stack,
  Button,
} from "@mui/material";

import girlsAspireNationalChampions from '../../images/g2010-aspire-national-champions.png'
import wildlingsCelebration2 from '../../images/test3.png'
import intramuralCampImage from '../../images/lgn-intramural.png'
import girlsAspireNationalChampionsFlyer from '../../images/g2010-aspire-national-champions-flyer.jpg'
import collegeCommitmentsImage from '../../images/elliot-1.jpg'
import wegmansMeals2Go from '../../images/wegmans-meals2go.png'

const promoSlides = [
  {
    title: "Fall Camps and Clinics",
    description: "Looking for extra touches to improve your game?  Or just looking to have some additional fun?  We have camps and clinics running throughout the Fall season.",
    buttonLabel: "SEE CAMPS AND CLINICS",
    buttonHref: "/programs/camps-and-clinics",
    image: intramuralCampImage,
    showButtons: true,
  },
  {
    title: "Girls 2010 United are GA Aspire National Champions!",
    description: "A historic achievement for Atlantic United and a proud moment for the girls' program. That makes 4 National Championships in Club History!  A fantastic job to coach Kim Onek and Girls 2010 Aspire team.",
    image: girlsAspireNationalChampionsFlyer,
    showButtons: false,
  },
  {
    title: "2025/2026 Graduating Class College Commitments",
    description: "Atlantic Untied has 37 college commitments in the 2025/2026 graduating class, making the club one of the top college recruitment programs in New York State.  Our players will go on to play at D1, D2, D3, and JUCO Universities.",
    buttonLabel: "More on College",
    buttonHref: "/college",
    image: collegeCommitmentsImage,
    showButtons: true,
  },
];

export default function Header() {
  const [activeSlide, setActiveSlide] = React.useState(0);
  const [isHolding, setIsHolding] = React.useState(false);

  React.useEffect(() => {
    if (isHolding) return undefined;

    const interval = setInterval(() => {
      setActiveSlide((current) => (current + 1) % promoSlides.length);
    }, 10000);

    return () => clearInterval(interval);
  }, [isHolding]);

  const currentSlide = promoSlides[activeSlide];

  const goToPreviousSlide = () => {
    setActiveSlide((current) => (current - 1 + promoSlides.length) % promoSlides.length);
  };

  const goToNextSlide = () => {
    setActiveSlide((current) => (current + 1) % promoSlides.length);
  };

  return (
        <Box
            sx={{
                position: 'relative',
                pt: {xs: '235px', sm: '200px', md: '270px', xl: '300px'},
                pb: 0,
                color: "#e9eef6",
                backgroundImage: {
                    xs: `linear-gradient(45deg, rgba(0, 0, 49, 0.85) 0%, rgba(255, 0, 0, 0.38) 100%), url(${wildlingsCelebration2})`,
                    sm: `linear-gradient(rgba(255, 0, 0, 0.5) 0%,rgba(0, 0, 49, 0.70) 50%, rgba(0, 0, 49, 0.35) 80%, rgba(255, 0, 0, 0.35) 100%), url(${girlsAspireNationalChampions})`

                },
                backgroundPosition: {xs: "center 65px", sm: "center 0px"},
                backgroundSize: { xs: '100% auto', sm: 'cover' },
                backgroundRepeat: "no-repeat",
            }}
        >
            <Box>
                <Typography variant="h2" sx={{fontSize: {xs: '40px', md: '50px', lg: '60px'}, textAlign: 'center'}}>
                    Atlantic United
                </Typography>
            </Box>

            <Box sx={{ mt: '20px'}}>
                <Typography variant="h4" sx={{fontSize: {xs: '20px', sm: '26px', md: '33px', lg: '35px'}, textAlign: 'center', mt: '20px'}}>
                    The Highest Achieving, Fastest Growing Soccer Club on Long Island.
                </Typography>
            </Box>

            <Box sx={{display: {xs: 'none', sm: 'block'}, mt: '20px'}}>
                <Typography variant="h6" sx={{pl: {xs: '20px', sm: '40px', md: '100px', lg: '140px'}, pr: {xs: '20px', sm: '70px', md: '100px', lg: '140px'}}}>
                    From aspiring young players to elite athletes, Atlantic United provides a home for every soccer enthusiast. We offer a comprehensive range of programs designed for all ages and skill levels, ensuring every player has the opportunity to grow, develop, and pursue their passion for the game. 
                </Typography>
            </Box>

            <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{mt: '35px', pb: { xs: '40px', sm: '45px', md: '55px' }, pl: {xs: '20px'}, pr: {xs: '20px'}, display: 'flex', justifyContent: 'center'}}>
                <Button sx={{transition: "opacity 0.3s, transform 0.3s", "&:hover": { opacity: 0.85, transform: "scale(1.05)" },}} size="large" variant="outlined" color="inherit" component={Link} to="/contact">
                    Contact Us
                </Button>
                <Button sx={{transition: "opacity 0.3s, transform 0.3s", "&:hover": { opacity: 0.85, transform: "scale(1.05)" },}} size="large" variant="contained" color="secondary" component={Link} to="/programs">
                    Our Programs
                </Button>
            </Stack>

            <Box
                sx={{
                    backgroundColor: { xs: '#000', sm: 'transparent' },
                    pt: { xs: 3, sm: 0 },
                    pb: { xs: '180px', sm: '100px', md: '170px', xl: '300px' },
                }}
            >
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: { xs: 0, sm: 3 }, px: { xs: 2, sm: 4 } }}>
                <Box sx={{ position: 'relative', width: { xs: '100%', sm: '680px' }, overflow: 'visible' }}>
                    <Button
                        onClick={goToPreviousSlide}
                        aria-label="Previous slide"
                        sx={{
                            position: 'absolute',
                            left: 0,
                            top: '50%',
                            transform: 'translate(-50%, -50%)',
                            zIndex: 2,
                            minWidth: 44,
                            width: 44,
                            height: 44,
                            borderRadius: '50%',
                            bgcolor: 'rgba(255,255,255,0.95)',
                            color: '#001a3d',
                            boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
                            '&:hover': { bgcolor: 'rgba(255,255,255,1)' },
                        }}
                    >
                        ←
                    </Button>
                    <Box
                        onMouseDown={() => setIsHolding(true)}
                        onMouseUp={() => setIsHolding(false)}
                        onMouseLeave={() => setIsHolding(false)}
                        onTouchStart={() => setIsHolding(true)}
                        onTouchEnd={() => setIsHolding(false)}
                        onTouchCancel={() => setIsHolding(false)}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                            height: { xs: 850, sm: 320 },
                            borderRadius: 3,
                            overflow: 'hidden',
                            bgcolor: 'rgba(255,255,255,0.95)',
                            boxShadow: '0 12px 36px rgba(0,0,0,0.25)',
                            color: '#001a3d',
                            userSelect: 'none',
                        }}
                    >
                        <Box sx={{ flex: 1, p: 2.5, display: 'flex', flexDirection: 'column' }}>
                            <Typography variant="subtitle2" sx={{ color: '#c62828', fontWeight: 700, fontSize: { xs: '1.1rem', sm: '1.2rem' }, mb: 1.25, textTransform: 'uppercase', letterSpacing: '0.08em', textAlign: 'center', transform: 'translateY(-20px)' }}>
                                The Latest
                            </Typography>
                            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'stretch', sm: 'center' }, gap: 2, flex: 1 }}>
                                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 1, lineHeight: 1.3 }}>
                                        {currentSlide.title}
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: 'rgba(0, 26, 61, 0.75)', mb: 1.5 }}>
                                        {currentSlide.description}
                                    </Typography>
                                </Box>
                                <Box
                                    sx={{
                                        width: { xs: '100%', sm: 160 },
                                        height: { xs: 400, sm: 160 },
                                        bgcolor: '#dfe7f2',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: 2,
                                        overflow: 'hidden',
                                        flexShrink: 0,
                                    }}
                                >
                                    <Box
                                        component="img"
                                        src={currentSlide.image}
                                        alt={currentSlide.title}
                                        sx={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            display: 'block',
                                        }}
                                    />
                                </Box>
                            </Box>
                            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                                {currentSlide.showButtons ? (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'center' }}>
                                        <Button
                                            component={currentSlide.buttonHref.startsWith('http') ? 'a' : Link}
                                            href={currentSlide.buttonHref.startsWith('http') ? currentSlide.buttonHref : undefined}
                                            to={!currentSlide.buttonHref.startsWith('http') ? currentSlide.buttonHref : undefined}
                                            target={currentSlide.buttonHref.startsWith('http') ? '_blank' : undefined}
                                            rel={currentSlide.buttonHref.startsWith('http') ? 'noopener noreferrer' : undefined}
                                            variant="contained"
                                            color="secondary"
                                            sx={{
                                                borderRadius: 999,
                                                px: 2.25,
                                                textTransform: 'none',
                                                fontWeight: 700,
                                            }}
                                        >
                                            {currentSlide.buttonLabel}
                                        </Button>
                                    </Box>
                                ) : (
                                    <Button
                                        component={Link}
                                        to="/about"
                                        variant="outlined"
                                        color="secondary"
                                        sx={{
                                            borderRadius: 999,
                                            px: 2.25,
                                            textTransform: 'none',
                                            fontWeight: 700,
                                            borderColor: 'rgba(0, 28, 61, 0.3)',
                                            color: '#001a3d',
                                            '&:hover': { borderColor: '#001a3d', bgcolor: 'rgba(0, 28, 61, 0.04)' },
                                        }}
                                    >
                                        More Titles
                                    </Button>
                                )}
                            </Box>
                        </Box>
                    </Box>
                    <Button
                        onClick={goToNextSlide}
                        aria-label="Next slide"
                        sx={{
                            position: 'absolute',
                            right: 0,
                            top: '50%',
                            transform: 'translate(50%, -50%)',
                            zIndex: 2,
                            minWidth: 44,
                            width: 44,
                            height: 44,
                            borderRadius: '50%',
                            bgcolor: 'rgba(255,255,255,0.95)',
                            color: '#001a3d',
                            boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
                            '&:hover': { bgcolor: 'rgba(255,255,255,1)' },
                        }}
                    >
                        →
                    </Button>
                </Box>
            </Box>

            <Box sx={{ position: 'absolute', right: 0, bottom: { xs: -40, sm: -80 } }}>
                <Box
                    component="a"
                    href="https://www.meals2go.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ display: 'block', width: { xs: 200, sm: 350 }, height: { xs: 200, sm: 350 } }}
                >
                    <Box
                        component="img"
                        src={wegmansMeals2Go}
                        alt="Wegmans Meals 2GO"
                        sx={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }}
                    />
                </Box>
            </Box>
            </Box>
        </Box>
  );
}